import React, { Component } from 'react';
import { Tabs } from 'antd';
import EmailsDashboardContainer from './EmailsDashboardContainer'
import SmsDashboardContainer from './SmsDashboardContainer'
import EmailLogsListContainer from './EmailLogsListContainer'
import SmsLogsListContainer from './SmsLogsListContainer'
import HolidaysListContainer from './HolidaysListContainer'


const { TabPane } = Tabs;
export default class MessagingDashboardContainer extends Component {

  constructor() {
    super();
    this.state = {
      defaultTab: 1
    };
    // this.setDefaultTab = this.setDefaultTab.bind(this);
  }

  componentWillMount() {

    const tab = new URLSearchParams(window.location.search).get('tab')
    let defaultTab = tab == null ? 1 : tab
    this.setState({
      defaultTab: `${defaultTab}`
    })

    const url = new URL(window.location)
    url.searchParams.delete('tab')
    window.history.replaceState(null, null, url)

  }

  render() {

    return (
      <div>
        <h1 className="dashboard-header">{'Emaily a SMS'}</h1>

        <div className="messaging-dashboard">
          <Tabs defaultActiveKey={this.state.defaultTab} type="card">
            <TabPane tab="Dashboard emailov" key="1">
              <EmailsDashboardContainer />
            </TabPane>
            <TabPane tab="Dashboard SMS" key="2">
              <SmsDashboardContainer />
            </TabPane>
            <TabPane tab="Zaslané emaily" key="3">
              <EmailLogsListContainer />
            </TabPane>
            <TabPane tab="Zaslané SMS" key="4">
              <SmsLogsListContainer />
            </TabPane>
            <TabPane tab="Sviatky a voľné dni" key="5">
              <HolidaysListContainer />
            </TabPane>
          </Tabs>
        </div >
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/containers/MessagingDashboardContainer.js